import React from 'react';
import { useApiLoadingPool, usePreventInfiniteLoading, useRouter, useScrollToTop, } from '@/util/hook/custom';
import useCallback from '@/util/hook/useCallback';
import useDispatch from '@/util/hook/useDispatch';
import useSelector from '@/util/hook/useSelector';
import { selectLiffId } from '@/util/redux/auth';
import { getGenderOptionList } from '../../util/helper/option';
import { handleParamVerifyAndCachePut } from '../../util/helper/paramVerifyAndCachePut';
import { useGetCareClientVisitorProfile } from '../../util/hook/useGetCareClientVisitorProfile';
import { useGetRemoteConfig } from '../../util/hook/useGetRemoteConfig';
import { useScrollToInputField } from '../../util/hook/useScrollToInputField';
import { useTrackBrowserHistory } from '../../util/hook/useTrackBrowserHistory';
import { useValidateCareClientVisitorProfileAndRedirect } from '../../util/hook/useValidateCareClientVisitorProfileAndRedirect';
import { useValidateCareOrderBabyForm } from '../../util/hook/useValidateCareOrderBabyForm';
import { careOrderBabyFormUpdate, selectCareOrderBabyForm, } from '../../redux/module/careOrderBabyForm';
import View from './View';
import { APP } from '../../config/app';
import { CareOrderBabyFormForCachePutDConverter } from '../../util/dataConverter/CareOrderBabyFormForCachePutDConverter';
import { CareOrderBabyFormForParamVerifyDConverter } from '../../util/dataConverter/CareOrderBabyFormForParamVerifyDConverter';
export default function Controller() {
    const { isLoading, setLoading, setApiProcessingPool, setApiDonePool } = useApiLoadingPool(true);
    const _id = useSelector(selectLiffId);
    const careOrderBabyForm = useSelector(selectCareOrderBabyForm);
    useTrackBrowserHistory();
    useGetRemoteConfig({ setApiProcessingPool, setApiDonePool });
    useGetCareClientVisitorProfile({
        setApiProcessingPool,
        setApiDonePool,
    });
    useValidateCareClientVisitorProfileAndRedirect({ redirectRoute: null });
    useScrollToTop();
    usePreventInfiniteLoading({ setApiProcessingPool, setApiDonePool });
    const dispatch = useDispatch();
    const { navigate, navigateError } = useRouter();
    const { getIsFieldError, setErrorTypes } = useValidateCareOrderBabyForm({
        contactName: careOrderBabyForm.contactName,
        contactGender: careOrderBabyForm.contactGender,
        contactPhone: careOrderBabyForm.contactPhone,
        contactEmail: careOrderBabyForm.contactEmail,
    });
    const isContactNameError = getIsFieldError('contactName');
    const isContactGenderError = getIsFieldError('contactGender');
    const isContactPhoneError = getIsFieldError('contactPhone');
    const isContactEmailError = getIsFieldError('contactEmail');
    const { careOrderBabyFormInputFieldRefMap, scrollToInputField } = useScrollToInputField();
    // event handlers
    const handleContactNameInputChange = useCallback((e) => {
        const contactName = e.target.value.replace(/[0-9]/g, '');
        dispatch(careOrderBabyFormUpdate({
            contactName,
        }));
    }, []);
    const handleContactGenderInputChange = useCallback((e) => {
        if (e.target.checked) {
            const contactGender = e.target.value;
            dispatch(careOrderBabyFormUpdate({
                contactGender,
            }));
        }
    }, []);
    const handleContactPhoneInputChange = useCallback((e) => {
        const contactPhone = e.target.value.replace(/[^0-9]/g, '');
        dispatch(careOrderBabyFormUpdate({
            contactPhone,
        }));
    }, []);
    const handleContactEmailInputChange = useCallback((e) => {
        const contactEmail = e.target.value;
        dispatch(careOrderBabyFormUpdate({
            contactEmail,
        }));
    }, []);
    const handleForwardButtonClick = async () => {
        const { data: paramVerifyParams } = new CareOrderBabyFormForParamVerifyDConverter({
            contactName: careOrderBabyForm.contactName,
            contactGender: careOrderBabyForm.contactGender,
            contactPhone: careOrderBabyForm.contactPhone,
            ...(careOrderBabyForm.contactEmail && { contactEmail: careOrderBabyForm.contactEmail }),
        });
        const { data: careOrderBabyFormForCachePut } = new CareOrderBabyFormForCachePutDConverter({
            careOrderBabyForm,
        });
        const { isSuccess } = await handleParamVerifyAndCachePut({
            _id,
            params: { _id, ...paramVerifyParams },
            careOrderBabyFormForCachePut,
            careOrderBabyFormInputFieldRefMap,
            pageRoute: APP.ROUTES.CONTACT_INFO,
            setLoading,
            setErrorTypes,
            scrollToInputField,
            navigateError,
        });
        if (isSuccess) {
            navigate(APP.ROUTES.CONTRACT);
        }
    };
    // options
    const genderOptionList = getGenderOptionList();
    return (<View 
    // data
    isLoading={isLoading} contactName={careOrderBabyForm.contactName} contactGender={careOrderBabyForm.contactGender} contactPhone={careOrderBabyForm.contactPhone} contactEmail={careOrderBabyForm.contactEmail} isContactNameError={isContactNameError} isContactGenderError={isContactGenderError} isContactPhoneError={isContactPhoneError} isContactEmailError={isContactEmailError} genderOptionList={genderOptionList} careOrderBabyFormInputFieldRefMap={careOrderBabyFormInputFieldRefMap} 
    // func
    handleContactNameInputChange={handleContactNameInputChange} handleContactGenderInputChange={handleContactGenderInputChange} handleContactPhoneInputChange={handleContactPhoneInputChange} handleContactEmailInputChange={handleContactEmailInputChange} handleForwardButtonClick={handleForwardButtonClick}/>);
}
